var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramEatingOut64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./EatingOut64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Eating-out",
    transform: "translate(14.000000, 5.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fork",
    transform: "translate(0.000000, 1.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,16 L12,52 L4,52 L4,16 L3,16 C1.34314575,16 2.02906125e-16,14.6568542 0,13 L0,0 L16,0 L16,13 C16,14.6568542 14.6568542,16 13,16 L12,16 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1 L12,9",
    id: "Gap"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,1 L8,9",
    id: "Gap"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,1 L4,9",
    id: "Gap"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Knife",
    transform: "translate(25.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-19",
    fill: "#FFCC00",
    points: "3 28.5 10 28.5 10 52.5 3 52.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,29.5 L0,29.5 L0,10.5 C0,10.5 0.0770971557,0.436617667 10,0.500299814 C10,0.56398196 10,29.5 10,29.5 Z",
    id: "Path-9",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramEatingOut64);
export default __webpack_public_path__ + "static/media/pictogramEatingOut64.041d971f076022556acf50fbd7290040.svg";
export { ForwardRef as ReactComponent };